import swal from "sweetalert2";
import AdminApi from "../../services/api";
import Autocomplete from 'vuejs-auto-complete';
import session from "../../services/session";
import Autocomplete2 from '../Shared/Autocomplete2';
import AutocompleteObject from '../Shared/AutocompleteObject';
import AutocompleteAddress from '../Shared/AutocompleteAddress';
import rowData from '!raw-loader!../../assets/files/all_data.txt';
import VueTimepicker from 'vue2-timepicker'


const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            tabIndex: 0,
            newestOrders: false,
            openEditOrder: false,
            visibleChooseTime: false,
            payByCredit: false,
            companyCount: 0,
            choosedTime:  {HH: '', mm: ''},
            scheduledTimeOrder:  {HH: '08', mm: '00'},
            addTitle: 'Dodaj',
            visibleScheduleTimer: false,
            orderToEdit: null,
            isDisabledAddButton: false,
            placeholderCompany: "Restoran",
            placeholderDriver: "Vozač",
            placeholderStreet: "Unesite adresu",
            restaurants: [],
            drivers: [],
            orders: [],
            activeOrders: [],
            finishedOrders: [],
            couriersActiveCount: new Map(),
            couriersFinishCount: new Map(),
            dispatchers: [],
            dispatchersIds: new Map(),
            adminsIds: new Map(),
            integrationsAdminIds: new Map(),
            dispatchersCount: [],
            dispatchersOrderMap: new Map(),
            openScheduleCourier: [],
            ordersByCompany: new Map(),
            filter: '',
            timeToLate: 25,
            showOnlyLateOrders: false,
            fromDate: new Date(),
            currentDate: new Date(),
            isDateError: null,
            selectedCompany: '',
            selectedDriver: '',
            selectedDiscount: 0,
            configDiscount: {
                city: 0,
                priceForCity: 0
            },
            countLegends: {
              l: 0,
              d: 0,
              i: 0,
              a: 0,
            },
            streets: [],
            newStreet: '',
            newStreetObject: null,
            homeNumber: '1',
            newSelectedCompany: null,
            newSelectedDriver: null,
            newSelectedDriverInRow: null,
            showVouchers: false,
            isFirstTime: true,
            configTime: 15,
            newOrder: {
                from: '',
                to: {
                    city: "Novi Sad",
                    country: "Srbija",
                    street: ""
                },
                time: 15,
                driver: '',
                price: '300',
                comment: '',
                voucher: null
            },
            calledFunc: null,
            calledFuncDrivers: null,
            isLoadingTabOrder: false,
            adminUsername: '',
            query: '?status=INITIAL&status=ACCEPTED&status=DECLINED&status=ASSIGNED&status=PICKED_UP&status=DELIVERED&status=REQUESTED&status=APPROVED&status=REJECTED'
        }
    },
    computed: {

        filteredOrders() {
            let ordersWithLate = this.showOnlyLateOrders ? this.orders.filter( o => this.isOrderLate(o)) : this.orders;
            return ordersWithLate.filter(item => {
                if(this.newestOrders){
                    const timeDiff = item.timestamp + (item.preparationTime * 60000) - Date.now();
                    if(timeDiff > (30 * 60 * 1000)) return false;
                }
                if(this.tabIndex === -1){
                    return (item.status === "REQUESTED" ) &&
                        (item.company.name.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                            this.checkCourierNull(item).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                            this.checkCourierLastNameNull(item).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                            item.address.street.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                            item.address.city.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                            item.comment.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 )
                }else if(this.tabIndex === 0){
                    return (item.status === "INITIAL" || item.status === "REQUESTED" || item.status === "ACCEPTED" || item.status === "DECLINED" || item.status === "PICKED_UP" || item.status === "ASSIGNED" || item.status === "APPROVED") &&
                        (item.company.name.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        this.checkCourierNull(item).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        this.checkCourierLastNameNull(item).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.address.street.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.address.city.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.comment.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 )
                }else if(this.tabIndex === 1) {
                    return ( item.status !== "DELIVERED" && item.status !== "REJECTED" && item.status !== "REQUESTED") && item.courier == null &&
                        (item.company.name.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        this.checkCourierNull(item).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        this.checkCourierLastNameNull(item).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.address.street.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.address.city.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.comment.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1)
                }else{
                    return (item.status === "DELIVERED" || item.status === "REJECTED") &&
                        (item.company.name.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        this.checkCourierNull(item).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        this.checkCourierLastNameNull(item).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.address.street.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.address.city.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.comment.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1)
                }
            }).filter(item => session.getRole() === 'ADMIN' ? true : item.createdBy.id !== '63c6fe4d8e46e43adc260862').sort((a, b) => (a.status === "DELIVERED" || a.status === "REJECTED") ? this.compareFinished(a,b) : this.compareActive(a,b));
        },

        filteredOrdersByCompany() {
            // return this.ordersByCompany.filter(function (item) {
            //     return item.key.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1
            // })

            return new Map([...this.ordersByCompany].filter(([k, v]) => k.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 || v.toString().toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ));
            // return this.ordersByCompany.filter(item => {
            //     return item.key.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1
            // }) //.sort((a, b) => a.status === "DELIVERED"? this.compareFinished(a,b) : this.compareActive(a,b));
        },
    },
    watch: {
        newStreet: function(val, oldVal) {
            // this.onSelectedAddress(val);
            // let prediction = this.streets.filter(item => item.toLowerCase().indexOf(val.toLowerCase().trim()) > -1)
        },
        newStreetObject: function(val, oldVal) {
            this.onSelectedAddress(val);
            this.calculateDiscount();
            // let prediction = this.streets.filter(item => item.toLowerCase().indexOf(val.toLowerCase().trim()) > -1)
        },
        newSelectedCompany: function(val, oldVal) {
           this.onSelectedRest(val);
           this.calculateDiscount();
        },
        newSelectedDriver: function(val, oldVal) {
            this.onSelectedDriver(val);
        },
        newSelectedDriverInRow: function(val, oldVal) {
            this.onUpdateDriver(val);
        },
        fromDate: function (val, oldVal){
            if(val !== this.currentDate){
                this.visibleScheduleTimer = true;
                this.addTitle = 'Zakaži'
            }else{
                this.visibleScheduleTimer = false;
                this.addTitle = 'Dodaj'
            }
        }
    },
    mounted() {
        this.startFetchOrders(true);
        this.startFetchDrivers();
    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeEdit', () => {
            _self.openEditOrder = false;
        });
        this.$topnavbar.$on('successEdit', (order) => {
            this.updateOrderAfterEdit(order);
            _self.openEditOrder = false;
            swal('Uspešno', 'Uspešno ažurirana porudžbina', 'success')
            _self.getOrders();
        });

    },
    beforeDestroy() {
        if(this.calledFunc != null){
            clearTimeout(this.calledFunc);
            this.calledFunc = null;
        }

        if(this.calledFuncDrivers != null){
            clearTimeout(this.calledFuncDrivers);
            this.calledFuncDrivers = null;
        }
    },
    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.adminUsername = session.getUsername()
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.currentDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.getDispatchers();
        // this.streets = this.allStreet();
        this.getAddresses();
        this.getCompanies();
        this.loadConfig();
        // this.getOrders();
    },
    components: { Autocomplete, Autocomplete2, AutocompleteObject, VueTimepicker, AutocompleteAddress },
    methods: {
        translateState: translateState,
        isAdmin: isAdmin,
        delayedSetTab: delayedSetTab,
        calculateDiscount: calculateDiscount,
        getCreator: getCreator,
        getCreatorStyle: getCreatorStyle,
        getDispatchers: getDispatchers,
        loadConfig: loadConfig,
        isOrderLate: isOrderLate,
        showPhoneNumber: showPhoneNumber,
        visibleDevelop: visibleDevelop,
        updateOrderAfterEdit: updateOrderAfterEdit,
        getAddresses: getAddresses,
        onSelectedAddress: onSelectedAddress,
        deleteSelectedStreet: deleteSelectedStreet,
        saveDriversLocation: saveDriversLocation,
        getCourierNotMoveStyle: getCourierNotMoveStyle,
        openEditModal: openEditModal,
        openTimeChooser: openTimeChooser,
        generateCompanyCounter: generateCompanyCounter,
        getNumberFromStreet: getNumberFromStreet,
        startFetchOrders: startFetchOrders,
        startFetchDrivers: startFetchDrivers,
        changedDate: changedDate,
        reasignDriver: reasignDriver,
        getRecommendation: getRecommendation,
        colorRow: colorRow,
        keymonitor: keymonitor,
        getDeliveryProblem: getDeliveryProblem,
        checkCourierLastNameNull: checkCourierLastNameNull,
        setTab: setTab,
        isFirstTimeDelivery: isFirstTimeDelivery,
        deleteVoucher: deleteVoucher,
        selectVoucher: selectVoucher,
        showCuponsInsteadPrice: showCuponsInsteadPrice,
        generateCouriersCount: generateCouriersCount,
        generateCouriersFinishedCount: generateCouriersFinishedCount,
        getVoucherStyle: getVoucherStyle,
        finishOrder: finishOrder,
        getModuleAdminStyle: getModuleAdminStyle,
        getStatusStyle: getStatusStyle,
        getMapDrivers: getMapDrivers,
        getCourierName: getCourierName,
        getVouchers: getVouchers,
        getGreenVoucher: getGreenVoucher,
        countLegendsFun: countLegendsFun,
        getOrders: getOrders,
        getCompanies: getCompanies,
        getDrivers: getDrivers,
        resetOrder: resetOrder,
        addOrder: addOrder,
        deleteOrder: deleteOrder,
        resendNotification: resendNotification,
        onSelectedRest: onSelectedRest,
        onUpdateDriver: onUpdateDriver,
        deleteSelectedRest: deleteSelectedRest,
        onSelectedDriver: onSelectedDriver,
        deleteSelectedDriver: deleteSelectedDriver,
        allStreet: allStreet,
        loadDrivers: loadDrivers,
        setNewDriver: setNewDriver,
        acceptCompanyOrder: acceptCompanyOrder,
        declineCompanyOrder: declineCompanyOrder,
        formatDateToTime: formatDateToTime,
        changeTime: changeTime,
        checkCourierNull: checkCourierNull,
        styleForNewCompany: styleForNewCompany,
        checkIfLate: checkIfLate,
        myStyle(){
            return ' width: 100%; height: 800px' + this.windowHeight;
        },
        compareActive(a, b) {
            let aTime = a.timestamp + (a.preparationTime * 60000);
            let bTime = b.timestamp + (b.preparationTime * 60000);
            if (aTime > bTime)
                return -1;
            if (aTime < bTime)
                return 1;
            return 0;
        },

        compareFinished(a, b) {
            let aTime = a.deliveredTime == null ? 0 : a.deliveredTime;
            let bTime = b.deliveredTime == null ? 0 : b.deliveredTime;
            if (aTime > bTime)
                return -1;
            if (aTime < bTime)
                return 1;
            return 0;
        },
        compareActiveDrivers(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrdersDrivers(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },


    }

}

function isAdmin(){
    return session.getRole() === 'ADMIN'
}

function getDispatchers(){
    let _self = this;
    AdminApiService.getDispatchers()
        .then((response) => {
            _self.dispatchers = response.data;
            _self.dispatchers.forEach(e =>{
                _self.dispatchersIds.set(e.id, e.id)
            })
            _self.adminsIds.set('6161e890ebb46d786eb963a0', '6161e890ebb46d786eb963a0') //sloba
            _self.adminsIds.set('6161e890ebb46d786eb963a3', '6161e890ebb46d786eb963a3') //marko
            _self.adminsIds.set('61fbc765b414eeefccb66421', '61fbc765b414eeefccb66421') //testadmin
            _self.integrationsAdminIds.set('624f3735bcdb4c55ec86d009', '624f3735bcdb4c55ec86d009') //integracija
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function loadConfig() {
    let _self = this;
    AdminApiService.getConfiguration()
        .then((response) => {
            _self.configDiscount.priceForCity = response.data.discounts.priceForCity;
            if(response.data.preparationTime == null || response.data.preparationTime === 0) return;
            _self.configTime = response.data.preparationTime;
            _self.newOrder.time = _self.configTime;
        })
        .catch(error => {
            swal('Greška', error.data.message, 'error')
        })
}


function getAddresses() {
    var _self = this;
    AdminApiService.getAddresses()
        .then((response) => {
            _self.streets = response.data.map(e => {
                return {
                    id: e.id,
                    name: e.name + ', ' + e.city,
                    price: e.neighborhood.price
                }
            });
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function changeTime(event) {
   if(event.mm !== '' && event.HH !== ''){
       const newDate = new Date();
       newDate.setHours(parseInt(event.HH), parseInt(event.mm), 0, 0);
       const currentDate = new Date();
       var diff = newDate.getTime() - currentDate.getTime();
       var nextTime = Math.floor(diff / 60000);
       if(nextTime > 0){
           this.newOrder.time = nextTime;
       }

       this.visibleChooseTime = false;
   }
}

function getVouchers(voucher) {
    var list = [];
    if(voucher.length === 0) return list;
    var tempVouchers = voucher.split(";").filter(e => e.length > 0);
    tempVouchers.forEach(e => {
        var tempVoucher =  e.split("-");
        list.push({
            voucher: tempVoucher[0],
            count: tempVoucher.length <= 1 ? 1 : parseInt(tempVoucher[1])
        })
    });

    return list;
}

function getGreenVoucher(voucher) {
    var returnValue = 0;
    if(voucher.length === 0) return list;
    var tempVouchers = voucher.split(";").filter(e => e.length > 0);
    tempVouchers.forEach(e => {
        var tempVoucher =  e.split("-");
        if(tempVoucher[0] === 'VOUCHER_GREEN'){
            returnValue = tempVoucher.length <= 1 ? 1 : parseInt(tempVoucher[1])
        }
    });

    return returnValue;
}

function setNewDriver(event) {
    if(event == null || event.length === 0){
        this.newSelectedDriver = null;
    }else{
        this.newSelectedDriver = event;
    }
}

function openTimeChooser() {
    var currentdate = new Date();
    this.choosedTime = {
        HH: '' + currentdate.getHours(),
        mm: '' //+ currentdate.getMinutes(),
    };


    this.visibleChooseTime = !this.visibleChooseTime;
}

function openEditModal(order) {
    this.openEditOrder = true;
    this.orderToEdit = order;
}

function getNumberFromStreet(street){
  let numbers = street.split(" ");
  if(street.length === 0) return "";
  return numbers[numbers.length - 1];
}

function getRecommendation(order) {
    var _self = this;
    _self.$topnavbar.$emit('load');
    AdminApiService.getRecommendation(order)
        .then((response) => {
            if(response.data !== null){
                swal({
                    title: 'Preporuka',
                    text: "Preporučeni vozač je " + response.data.username +". Da li želite da ga prihvatite? ",
                    type: 'info',
                    showCancelButton: true,
                    cancelButtonText: 'Ne',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Da',
                    customClass: 'swal2-warning'
                }).then(function () {
                    _self.$topnavbar.$emit('load');
                    AdminApiService.connectDriver(order, response.data.id)
                        .then((response) => {
                            swal('Uspešno', 'Dodelili ste porudžbinu', 'success')
                        })
                        .catch((error) => {
                            swal('Greška', error.data.message, 'error')
                        })

                });
            }else{
                swal('Info', 'Trenutno nema vozača za preporuku', 'success')
            }
        })
        .catch((error) => {
            swal('Greška', error.data.message, 'error')
        })
}


function translateState(state) {
    switch (state) {
        case "INITIAL": return "Kreirano";
        case "DECLINED": return "Vozač odbio";
        case "ACCEPTED": return "Vozač prihvatio";
        case "ASSIGNED": return "Dodeljeno";
        case "PICKED_UP": return "Pokupljeno";
        case "DELIVERED": return "Dostavljeno";
        case "REQUESTED": return "Lokal kreirao";
        case "APPROVED": return "Dispecer odobrio";
        case "REJECTED": return "Dispecer odbio";
    }
    return "";
}

function reasignDriver(orderId) {
    var _self = this;
    _self.$topnavbar.$emit('load');
    AdminApiService.connectDriver(orderId, null)
        .then((response) => {
            swal('Uspešno', 'Uspešno ste skinuli vozača', 'success')
            _self.getOrders();
        })
        .catch((error) => {
            swal('Greška', error.data.message, 'error')
        })
}

function startFetchDrivers() {
    this.getDrivers();
    let _self = this;
    if(_self.calledFuncDrivers != null){
        clearTimeout(_self.calledFuncDrivers);
    }
    _self.calledFuncDrivers = setTimeout(function(){ _self.startFetchDrivers(); }, 30000);
}


function startFetchOrders(isFirstTime) {
    if(!isFirstTime){
        if(this.query !== '?status=DELIVERED&status=REJECTED'){
            this.getOrders();
        }
    }else{
        this.getOrders();
    }
    let _self = this;
    if(_self.calledFunc != null){
        clearTimeout(_self.calledFunc);
    }
    _self.calledFunc = setTimeout(function(){ _self.startFetchOrders(false); }, 12000);
}

function changedDate() {
   this.getOrders();
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        // alert();
    }
}

function addOrder() {
    var _self = this;
    var address = this.newStreet.split(",");
    if(this.newOrder.from === "" ||
        this.newStreet === "" ||
        this.newOrder.time < 0 ||
        this.newOrder.price < 0) {
        swal('Greška', "Molimo popunite Lokal, Adresu, Vreme i Cenu. ", 'error')
        return;
    }
    if(address.length < 2){
        swal('Greška', "Adresa nije validna, izaberite adresu iz liste.", 'error')
        return;
    }

    if(this.newSelectedCompany.usingVouchers === false && _self.payByCredit){
        swal('Greška', "Kompanija ne koristi kredite. Plaćanje omogućeno jedino u dinarima.", 'error')
        return;
    }
    if(this.newOrder.driver !== ""){
        if(!this.openScheduleCourier.includes(this.newOrder.driver)){
            swal("Upozorenje", "Vozač nije otvorio smenu. Molimo Vas da ga kontaktirate kako bi započeo smenu.", 'info')
            return;
        }
    }

    var timestamp = null;
    if(this.currentDate !== this.fromDate){
        if(this.fromDate < this.currentDate){
            swal('Greška', 'Ne možete da zakažete porudžbine u prošlosti.', 'error');
            return;
        }
        timestamp = Date.parse(_self.fromDate);
        if(isNaN(timestamp)){
            swal('Greška', 'Izaberite validan datum', 'error');
            return;
        }
        if(this.scheduledTimeOrder.HH == null || this.scheduledTimeOrder.HH === ''
            || this.scheduledTimeOrder.mm == null || this.scheduledTimeOrder.mm === ''){
            swal('Greška', 'Izaberite validan datum za zakazivanje.' , 'error');
            return;
        }
        var date =  new Date(timestamp);
        date.setHours(parseInt(this.scheduledTimeOrder.HH), parseInt(this.scheduledTimeOrder.mm), 0, 0)
        timestamp = date.getTime();

    }
    _self.newOrder.voucher = _self.payByCredit ? "VOUCHER_GREEN-"+_self.newOrder.price : null;
    this.isDisabledAddButton = true;
    this.$topnavbar.$emit('load');
    let homeNumber = this.homeNumber.length === 0 ? "1" : "" + this.homeNumber;
    const newModel = {
        fromCompany: this.newOrder.from,
        to: {
            city: address.length > 1 ? address[1] : "Novi Sad", // this.newOrder.to.city,
            country: this.newOrder.to.country,
            street: address.length > 0 ? (address[0] + " " + homeNumber) : "" // this.newStreet
        },
        preparationTime: this.newOrder.time,
        courier: this.newOrder.driver === "" ? null : this.newOrder.driver,
        price: this.newOrder.voucher == null ? this.newOrder.price : 0,
        voucher: this.newOrder.voucher,
        timestamp: timestamp,
        comment: this.newOrder.comment

    };
    AdminApiService.addOrder(newModel)
        .then((response) => {
            swal('Uspešno', 'Uspešno kreirana porudžbina', 'success')
            _self.getOrders();
            _self.resetOrder();
            _self.$tabEvent.emit('onNewOrder', JSON.stringify(newModel));
            this.isDisabledAddButton = false;
            console.log(response.data)
            if(response.data.recommendationCourier != null && response.data.recommendationCourier.id != null){
                swal({
                    title: 'Preporuka',
                    text: "Preporučeni vozač je " + response.data.recommendationCourier.username +". Da li želite da ga prihvatite? ",
                    type: 'info',
                    showCancelButton: true,
                    cancelButtonText: 'Ne',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Da',
                    customClass: 'swal2-warning'
                }).then(function () {
                    _self.$topnavbar.$emit('load');
                    AdminApiService.connectDriver(response.data.id, response.data.recommendationCourier.id)
                        .then((response) => {
                            swal('Uspešno', 'Dodelili ste porudžbinu', 'success')
                        })
                        .catch((error) => {
                            swal('Greška', error.data.message, 'error')
                        })

                });
            }

        })
        .catch((error) => {
            this.isDisabledAddButton = false;
            swal('Greška', error.data.localized_error_message, 'error')

        })


    // this.orders.push(newModel);

    // this.$tabEvent.emit('onNewOrder', JSON.stringify(newModel));
    // this.resetOrder();
}

function resetOrder() {
    this.newOrder = {
        from: '',
        to: {
            city: "Novi Sad",
            country: "Srbija",
            street: ""
        },
        time: this.configTime,
        driver: '',
        price: '300',
        voucher: null,
        comment: ''
    };
    this.showVouchers = false;
    this.newStreet = '';
    this.homeNumber = '1';
    this.selectedCompany = '';
    this.selectedDriver = '';
    this.newSelectedCompany = null
    this.newSelectedDriver = null
    this.newSelectedDriverInRow = null
    this.payByCredit = false;
    this.$topnavbar.$emit('clearACObject');
    this.deleteSelectedStreet();
}

function getCourierName(order){
    if(order.courier == null) return null;
    return order.courier.lastName;
}

function getCompanies() {
    var _self = this;
    AdminApiService.getCompanies()
        .then((response) => {
            _self.restaurants = response.data.filter(e => !e.internalName.includes("_archive_"));
            _self.restaurants.forEach(e => {
                e.name = e.internalName;
            })
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getOrders() {
    var _self = this;
    var calendarTimestamp = Date.parse(_self.fromDate);
    if(isNaN(calendarTimestamp)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    _self.isDateError = null
    // var activeParams = "?status=INITIAL&status=ACCEPTED&status=DECLINED&status=ASSIGNED&status=PICKED_UP&status=DELIVERED&status=REQUESTED&status=APPROVED&status=REJECTED";
    var timestamp = "&timestamp=" + calendarTimestamp;
    AdminApiService.getOrders(_self.query, timestamp)
        .then((response) => {
            // item.status === "INITIAL" || item.status === "REQUESTED" || item.status === "ACCEPTED" || item.status === "DECLINED" || item.status === "PICKED_UP" || item.status === "ASSIGNED" || item.status === "APPROVED"
            if(_self.isFirstTime){
                _self.orders = response.data;
                _self.activeOrders = response.data.filter(item => item.status === "INITIAL" || item.status === "REQUESTED" || item.status === "ACCEPTED" || item.status === "DECLINED" || item.status === "PICKED_UP" || item.status === "ASSIGNED" || item.status === "APPROVED")
                _self.finishedOrders = response.data.filter(item => item.status === "DELIVERED" || item.status === "REJECTED")
                _self.isFirstTime = false;
                _self.setTab(_self.tabIndex);
                _self.generateCouriersCount(_self.activeOrders);
                _self.generateCouriersFinishedCount(_self.finishedOrders);
                _self.getDrivers();
            }else{
                if(_self.query === '?status=INITIAL&status=ACCEPTED&status=DECLINED&status=ASSIGNED&status=PICKED_UP&status=REQUESTED&status=APPROVED'){
                    _self.activeOrders = response.data;
                }else if(_self.query === '?status=DELIVERED&status=REJECTED'){
                    _self.finishedOrders = response.data;
                }
                var newOrders = [];
                _self.activeOrders.forEach(e => newOrders.push(e));
                _self.finishedOrders.forEach(e => newOrders.push(e));
                _self.orders = newOrders;
                _self.generateCouriersCount(_self.activeOrders);
                _self.generateCouriersFinishedCount(_self.finishedOrders);
                _self.countLegendsFun();
            }
            _self.isLoadingTabOrder = false;
            //TODO ovo je bilo pre optimizacije
            // _self.orders = response.data;
            // console.log("AKTIVNIH " + _self.activeOrders.length + "ZAVRSENE " + _self.finishedOrders.length + " UKUPNO " + _self.orders.length );

            var count = _self.orders.filter(item => item.status === "REQUESTED").length;
            if(count > _self.companyCount){
                _self.$toasted.error('Nova porudžbina od lokala',{ position: "top-left", duration: 3000})
            }
            _self.dispatchersOrderMap = new Map();
            _self.dispatchersCount = [];
            _self.orders.forEach(o => {
                var approvedId = o.approvedBy != null ? o.approvedBy.id : null
                var id = approvedId != null && approvedId !== '' ? o.approvedBy.id : o.createdBy.id;
                if(_self.dispatchersOrderMap.get(id) == null){
                    _self.dispatchersOrderMap.set(id, 0)
                }
                _self.dispatchersOrderMap.set(id, _self.dispatchersOrderMap.get(id) + 1)
            })
            _self.dispatchers.forEach(d => {
                _self.dispatchersCount.push({ name: d.firstName + " " + d.lastName, count: _self.dispatchersOrderMap.get(d.id) != null ? _self.dispatchersOrderMap.get(d.id) : 0 })
            })
            _self.companyCount = count;
        })
        .catch((error) => {
            _self.isLoadingTabOrder = false;
            swal('Greška', error.data.message, 'error')
        })
}

function countLegendsFun(){
    this.countLegends.l  = 0;
    this.countLegends.d  = 0;
    this.countLegends.i  = 0;
    this.countLegends.a  = 0;
    this.orders.forEach( o => {
        var c = this.getCreator(o)
        switch (c){
           case "(D)": this.countLegends.d = this.countLegends.d + 1;break;
           case "(I)": this.countLegends.i = this.countLegends.i + 1;break;
           case "(A)": this.countLegends.a = this.countLegends.a + 1;break;
           case "(L)": this.countLegends.l = this.countLegends.l + 1;break;
           default : break;
        }
    })
}

function generateCouriersCount(activeOrders){
    let _self = this;
    let courierMap = new Map()
    var i = 0;
    for(i =0; i < activeOrders.length; i++){
        if(activeOrders[i].courier != null){
            var courierId = activeOrders[i].courier.id;
            if(courierMap.has(courierId)){
                var currentCount = courierMap.get(courierId);
                courierMap.set(courierId, currentCount + 1)
            }else{
                courierMap.set(courierId, 1);
            }
        }
    }
    _self.couriersActiveCount = courierMap;
}

function generateCouriersFinishedCount(finishedOrders){
    let _self = this;
    let courierMap = new Map()
    var i = 0;
    for(i =0; i < finishedOrders.length; i++){
        if(finishedOrders[i].courier != null){
            var courierId = finishedOrders[i].courier.id;
            if(courierMap.has(courierId)){
                var currentCount = courierMap.get(courierId);
                courierMap.set(courierId, currentCount + 1)
            }else{
                courierMap.set(courierId, 1);
            }
        }
    }
    _self.couriersFinishCount = courierMap;
}

function delayedSetTab(index){
    let _self = this;
    setTimeout(function(){ _self.setTab(index); }, 500);
}


function getDrivers() {
    //prvo povuci schedule pa onda drivers
    var _self = this;
    var calendarTimestamp = Date.parse(_self.fromDate);
    if(isNaN(calendarTimestamp)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    _self.isDateError = null;
    var date =  "?fromTimestamp=" + calendarTimestamp + "&toTimestamp="+calendarTimestamp;
    AdminApiService.getSchedules(date)
        .then((response) => {
            _self.openScheduleCourier = []
            response.data.filter(f => f.completionTime == null).forEach(e => {
                if(e.courier != null && e.courier.id != null && e.startTime != null){
                    _self.openScheduleCourier.push(e.courier.id)
                }
            })
            _self.loadDrivers();
        })
        .catch((error) => {
            console.log(error);
        })


}

function loadDrivers(){
    var _self = this;
    var activeParams = "?active=true";
    AdminApiService.getDrivers(activeParams)
        .then((response) => {
            _self.drivers = []
            saveDriversLocation(response.data);
            _self.drivers = response.data.map(e => {
                let activeOrders = _self.couriersActiveCount.get(e.id) != null ? _self.couriersActiveCount.get(e.id) : 0;
                let finishedOrders = _self.couriersFinishCount.get(e.id) != null ? _self.couriersFinishCount.get(e.id) : 0;
                return {
                    id: e.id,
                    name: e.lastName,
                    active: e.active,
                    isOpenShift: _self.openScheduleCourier.includes(e.id),
                    activeOrders: activeOrders,
                    finishedOrders: finishedOrders,
                    lastAddress: e.lastDeliveredAddress != null && e.lastDeliveredAddress.street != null && activeOrders === 0 ? e.lastDeliveredAddress.street : ""
                }
            }).sort((a,b) => _self.compareActiveDrivers(a,b)).sort((a,b) => _self.compareOrdersDrivers(a,b))
        })
        .catch((error) => {
            console.log(error);
            // swal('Greška', error.data.localized_error_message, 'error')
        })
}

function saveDriversLocation(drivers){
    var i = 0;
    for(i = 0;i < drivers.length; i++){
        var currentDriver = drivers[i];
        var currentLat = currentDriver.position != null && currentDriver.position.lat != null ? currentDriver.position.lat : 0.0;
        var currentLng = currentDriver.position != null && currentDriver.position.lng != null ? currentDriver.position.lng : 0.0;
        var savedCourier = session.getCourierLocation(currentDriver.id)
        var courierLocation = {
            id: currentDriver.id,
            timestamp: Date.now(),
            lat: currentLat,
            lng: currentLng,
        }
        if(savedCourier == null || (savedCourier.lat !== currentLat || savedCourier.lng !== currentLng)){
            session.saveCourierLocation(courierLocation)
        }
    }
}


function deleteOrder(order) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete poružbinu iz " + order.company.internalName + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteOrder(order.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali porudžbinu', 'success')
                _self.getOrders();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });


}


function resendNotification(order) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da posaljete notifikaciju kuriru: " + order.courier.lastName + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.resendNotificationToCourier(order.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste poslali obaveštenje', 'success')
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });


}


function onSelectedAddress(data) {
    if(data != null) {
        this.newOrder.price = data.price != null ? data.price : this.newOrder.price;
        this.newStreet = data.name;
    }else{
        this.newOrder.price = 300;
        this.newStreet = '';
    }
}


function onSelectedRest(data) {
    if(data == null) {
        this.newOrder.from = '';
        this.selectedCompany = '';
        return;
    }
    if(this.newOrder.from.includes(data.name)) return;
    this.newOrder.from =  data.id;
    this.selectedCompany =  data.name;
    this.selectedDiscount = data.discounts != null && data.discounts.city != null ? parseFloat(data.discounts.city) : 0
}

function calculateDiscount(){
    console.log()
    if(this.newStreetObject == null || this.newStreetObject === '') return;
    if(this.selectedCompany === '') return;
    if(this.configDiscount.priceForCity !== this.newOrder.price) return;
    this.newOrder.price = this.newOrder.price - this.selectedDiscount;
}

function deleteSelectedRest() {
    this.newOrder.from = '';
    this.selectedCompany = ''
    this.newSelectedCompany = null;
}

function deleteSelectedStreet() {
    this.newStreet = '';
    this.newStreetObject = null;
    this.$topnavbar.$emit('clearAddressObject');
}

function onSelectedDriver(data) {
    if(data == null){
        this.newOrder.driver = '';
        this.selectedDriver =  '';
        return;
    }
    // if(this.newOrder.driver.includes(data.name)) return;
    this.newOrder.driver = data.id;
    this.selectedDriver =  data.name;
    // if(this.newOrder.driver.includes(data.display)) return;
    // this.newOrder.driver = data.selectedObject.id;
    // this.selectedDriver =  data.display;
}

function deleteSelectedDriver() {
    this.newOrder.driver = '';
    this.selectedDriver = ''
    this.newSelectedDriver = null;
}

function onUpdateDriver(data) {
    if(data == null || data.order == null) return
    if(data.isOpenShift === false){
        this.$toasted.info('Vozač nije otvorio smenu. Molimo Vas da ga kontaktirate kako bi započeo smenu.',{ position: "top-left", duration: 3000,})
        this.newSelectedDriver = null
        this.newSelectedDriverInRow = null
        return;
    }
    let _self = this;
    let order = data.order;
    const newModel = {
        fromCompany: order.company.id,
        to: {
            city: order.address.city,
            country: order.address.country,
            street: order.address.street
        },
        preparationTime: order.preparationTime,
        customerPhoneNumber: order.customerPhoneNumber,
        courier: data.id,
        price: order.price,
        orderPrice: order.orderPrice,
        comment: order.comment
    };
    this.$topnavbar.$emit('load');
    AdminApiService.updateOrder(newModel, order.id)
        .then((response) => {
            swal('Uspešno', 'Uspešno dodeljen vozač', 'success')
            _self.updateOrderAfterEdit(response.data);
            _self.getOrders();
            _self.$tabEvent.emit('onNewOrder', JSON.stringify(newModel));

        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })

}


function colorRow(index) {
    return "";
    if(index % 2 === 0){
        return "background: #999999"
    }else{
        return "background: #727272"
    }

}

function getMapDrivers(order) {
   return this.drivers.map(e => {
        return {
            id: e.id,
            name: e.name,
            isOpenShift: e.isOpenShift,
            order: order
        }
    })
}

function setTab(index) {
    if(index !== 2){
        this.showOnlyLateOrders = false;
        this.timeToLate = 25;
    }
    if(index === 0 || index === 1){
        if(!this.isFirstTime){
            this.isLoadingTabOrder = true;
            this.query = '?status=INITIAL&status=ACCEPTED&status=DECLINED&status=ASSIGNED&status=PICKED_UP&status=REQUESTED&status=APPROVED';
            this.getOrders();
        }
    }else if(index === 2){
        if(!this.isFirstTime){
            this.isLoadingTabOrder = true;
            this.query = '?status=DELIVERED&status=REJECTED';
            this.getOrders();
        }
    }else if(index === 3){
        this.generateCompanyCounter();
    }
    this.tabIndex = index;
}

function generateCompanyCounter() {
    let _self = this;
    _self.ordersByCompany = new Map();
    var i = 0;
    for(i =0; i < _self.orders.length; i++){
        var currentCompany = _self.orders[i].company.name;
        if(_self.ordersByCompany.has(currentCompany)){
            var currentCount = _self.ordersByCompany.get(currentCompany);
            _self.ordersByCompany.set(currentCompany, currentCount + 1)
        }else{
            _self.ordersByCompany.set(currentCompany, 1);
        }
        // _self.ordersByCompany.push('': 1)
        // _self.ordersByCompany.push({company: _self.orders[i].company.name, count: 1})
    }
    _self.ordersByCompany = new Map([..._self.ordersByCompany.entries()].sort());
    // _self.ordersByCompany = mapAsc
}


function getModuleAdminStyle(index) {
    if(index === this.tabIndex){
        return "border-color: #70b1e7;"
    }else {
        return "border-color: black;"
    }
}

function allStreet() {
    return rowData.split("\n");
}

function acceptCompanyOrder(order) {
    let _self  = this;
    AdminApiService.updateOrderStatus(order.id, 'APPROVED')
        .then((response) => {
            swal('Uspešno', 'Uspešno ste potvrdili porudžbinu. Sada je možete videti u aktivnim porudžbinama.', 'success')
            _self.getOrders();
        })
        .catch((error) => {
            swal('Greška', error.data.message, 'error')
        })
}


function declineCompanyOrder(order) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da odbijete poružbinu iz " + order.company.internalName + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.updateOrderStatus(order.id, 'REJECTED')
            .then((response) => {
                swal('Uspešno', 'Uspešno ste odbili porudžbinu. Sada je možete videti u završenim porudžbinama.', 'success');
                _self.getOrders();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}

function formatDateToTime(date) {
    var localTime  =  date.toLocaleTimeString();
    var tempTime = localTime.split(':');
    return tempTime[0] + ':' + tempTime[1];
}

function finishOrder(order) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da završite poružbinu iz " + order.company.internalName + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.updateOrderStatus(order.id, 'DELIVERED')
            .then((response) => {
                swal('Uspešno', 'Uspešno ste završili porudžbinu. Sada je možete videti u završenim porudžbinama.', 'success');
                _self.getOrders();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });

}

function getVoucherStyle(voucher) {
    let voucherId = voucher.split("-");
    switch (voucherId[0]) {
        case 'VOUCHER_BLUE': return "width: 30px; height: 24px; background: cornflowerblue; color: black;";
        case 'VOUCHER_GREEN': return "width: 30px; height: 24px; background: forestgreen; color: black;";
        case 'VOUCHER_WHITE': return "width: 30px; height: 24px; background: white; color: black;";
        default : return "width: 0px; height: 0px;"
    }
}

function getStatusStyle(order) {
    if(order.status === 'ASSIGNED'){
        return "background: #d33; color: white;"
    }
    if(order.status === 'REQUESTED'){
        return "background: #946d13; color: white;"
    }
    return ""//"background: black; color: white;"
}

function visibleDevelop() {
    return localStorage.getItem('sb95') === 'braca'
}

function showCuponsInsteadPrice() {
    this.showVouchers = !this.showVouchers;
}

function selectVoucher(voucher) {
    this.newOrder.voucher = voucher;
}

function deleteVoucher() {
    this.newOrder.voucher = null;
    this.showVouchers = false;
}

function updateOrderAfterEdit(order) {
    if(order == null) return;
    this.orders = this.orders.map(e => e.id === order.id ? order : e);
}

function checkIfLate(order){
    if(order.status !== 'REJECTED' && order.status !== 'DELIVERED') return '';
    if(order.deliveredTime == null) return ''
    let timeToPickUp = order.timestamp  + order.preparationTime * 60000;
    let minutesTolate = this.timeToLate;
    if(order.deliveredTime - timeToPickUp > (minutesTolate * 60000)){
        return 'background: red';
    }else {
        return '';
    }
}

function isOrderLate(order){
    if(order.status !== 'REJECTED' && order.status !== 'DELIVERED') return false;
    if(order.deliveredTime == null) return false
    let timeToPickUp = order.timestamp  + order.preparationTime * 60000;
    let minutesTolate = this.timeToLate;
    if(order.deliveredTime - timeToPickUp > (minutesTolate * 60000)){
        return true;
    }else {
        return false;
    }
}

function checkCourierNull(data) {
    if(data == null) return '';
    if(data.courier == null || data.courier.firstName == null) return '';
    return data.courier.firstName;
}

function checkCourierLastNameNull(data) {
    if(data == null) return '';
    if(data.courier == null || data.courier.lastName == null) return '';
    return data.courier.lastName;
}

function showPhoneNumber(order){
    swal('Info', 'Broj telefona kupca: '+ order.customerPhoneNumber , 'warning')
}

function getDeliveryProblem(order){
    // if(order.deliveryProblemNote == null) return '';
    return '<i style="color: red; font-style: italic">Problem na adresi! </i>';
}

function getCourierNotMoveStyle(courier){
    let savedDriver = session.getCourierLocation(courier.id)
    let now = Date.now();
    if(savedDriver == null){
        return "color: white;"
    }else if(now - savedDriver.timestamp > 600000){
        return "color: red;"
    }else if(now - savedDriver.timestamp > 180000){
        return "color: orange;"
    }else{
        return "color: white;";
    }
}

function isFirstTimeDelivery(order){
    if(order.customer == null) return false
    return  order.customer.firstTimeDelivery;
}

function getCreator(o){
    var id = o.createdBy.id != null ? o.createdBy.id : '';
    if(this.integrationsAdminIds.get(id) != null){
        return "(I)";
    }
    if(this.adminsIds.get(id) != null){
        return "(A)";
    }
    if(this.dispatchersIds.get(id) != null){
        return "(D)"
    }
    return "(L)"
}

function getCreatorStyle(o){
    var id = o.createdBy.id != null ? o.createdBy.id : '';
    if(this.integrationsAdminIds.get(id) != null){
        return "color: cornflowerblue;";
    }
    if(this.adminsIds.get(id) != null){
        return "color: yellow;;";
    }
    if(this.dispatchersIds.get(id) != null){
        return "color: green;"
    }
    return "color: orange;"
}

function styleForNewCompany(order){
    if(order.createdBy.id === '63c6fe4d8e46e43adc260862'){
        return 'background: red';
    }
    return '';
}


// WEBPACK FOOTER //
// ./src/components/Orders/Orders.js